import Color from 'color'

export const getThemeFromUrlParams = (
    urlParams: ButtonUrlParams
): ButtonStyleProperties | null => {
    const textColor = urlParams['button-color']
    const backgroundColor = urlParams['button-background-color']
    try {
        const buttonColor = textColor ? new Color(textColor).string() : '#fff',
            buttonBackgroundColor = backgroundColor
                ? new Color(backgroundColor).string()
                : '#ffa100'

        return {
            buttonColor,
            buttonBackgroundColor,
        }
    } catch {
        throw new Error(
            'The currently configured custom colors are not all valid CSS colors.'
        )
    }
}

export const applyTheme = (
    rootElement: HTMLElement,
    theme: ButtonStyleProperties
) => {
    rootElement.style.backgroundColor = 'transparent'

    rootElement.style.setProperty('--button-color', theme.buttonColor)
    rootElement.style.setProperty(
        '--button-background-color',
        theme.buttonBackgroundColor
    )
}
